export * as PaymentExpectationApi from './api';
export var InvestmentPaymentType;
(function (InvestmentPaymentType) {
    InvestmentPaymentType["Banked"] = "BANKED";
    InvestmentPaymentType["ManuallyRecorded"] = "MANUALLY_RECORDED";
    InvestmentPaymentType["Reconciled"] = "RECONCILED";
    InvestmentPaymentType["CashBalance"] = "CASH_BALANCE";
})(InvestmentPaymentType || (InvestmentPaymentType = {}));
//# sourceMappingURL=index.js.map